export const calculateClassesLeft = (startDate?: string, endDate?: string, dayOfWeek?: string, exceptions?: string[]) => {
  if (!startDate || !endDate || !dayOfWeek) {
    return 0;
  }

  // Using UTC is crucial for correct date calculations across different timezones.
  const getUTCDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(Number);
    // Month is 0-indexed in JavaScript Date (0=Jan, 1=Feb, etc.)
    return new Date(Date.UTC(year, month - 1, day));
  };

  // Get today's date in UTC (start of day)
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);

  const start = getUTCDate(startDate);
  const end = getUTCDate(endDate);

  // If the program hasn't started yet, calculate total classes
  if (today.getTime() < start.getTime()) {
    return calculateTotalClasses(startDate, endDate, dayOfWeek, exceptions);
  }

  // If the program has already ended, return 0
  if (today.getTime() > end.getTime()) {
    return 0;
  }

  const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(dayOfWeek);

  // Create a Set of exception date timestamps for fast lookups.
  const exceptionTimeSet = new Set(exceptions?.map(ex => getUTCDate(ex).getTime()) || []);

  let count = 0;
  // Start counting from today (or the program start date if today is before it)
  let currentDate = new Date(Math.max(today.getTime(), start.getTime()));

  while (currentDate.getTime() <= end.getTime()) {
    // Use getUTCDay() to get the day of the week in UTC.
    if (currentDate.getUTCDay() === dayIndex) {
      // Check if the current date is not an exception day.
      if (!exceptionTimeSet.has(currentDate.getTime())) {
        count++;
      }
    }
    // Advance to the next day in UTC.
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
  }

  return count;
};

export const calculateTotalClasses = (startDate?: string, endDate?: string, dayOfWeek?: string, exceptions?: string[]) => {
  if (!startDate || !endDate || !dayOfWeek) {
    return 0;
  }

  const getUTCDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day));
  };

  const start = getUTCDate(startDate);
  const end = getUTCDate(endDate);

  const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(dayOfWeek);

  const exceptionTimeSet = new Set(exceptions?.map(ex => getUTCDate(ex).getTime()) || []);

  let count = 0;
  let currentDate = new Date(start);

  while (currentDate.getTime() <= end.getTime()) {
    if (currentDate.getUTCDay() === dayIndex) {
      if (!exceptionTimeSet.has(currentDate.getTime())) {
        count++;
      }
    }
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
  }

  return count;
};